/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Payment_Method_CardInputs */

const vi_customer_debt_payment_method_card = /** @type {(inputs: Customer_Debt_Payment_Method_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thẻ`)
};

/**

* @param {Customer_Debt_Payment_Method_CardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_payment_method_card = /** @type {((inputs?: Customer_Debt_Payment_Method_CardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Payment_Method_CardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_payment_method_card(inputs)
});